export const states = [
  "Selangor",
  "Kuala Lumpur",
  "Johor",
  "Penang",
  "Perak",
  "Kedah",
  "Negeri Sembilan",
  "Melaka",
  "Pahang",
  "Terengganu",
  "Kelantan",
  "Perlis",
  "Sabah",
  "Sarawak",
];

export const citiesByState = {
  Selangor: [
    "Shah Alam",
    "Petaling Jaya",
    "Subang Jaya",
    "Klang",
    "Puchong",
    "Kajang",
    "Selayang",
    "Rawang",
    "Gombak",
    "Cheras",
    "Banting",
    "Sepang",
    "Hulu Langat",
  ],
  "Kuala Lumpur": [
    "KL City Center",
    "Bukit Bintang",
    "Bangsar",
    "Mont Kiara",
    "Kepong",
    "Cheras_KL",
    "Wangsa Maju",
    "Setapak",
    "Sentul",
    "Titiwangsa",
    "Segambut",
    "Batu Caves",
  ],
  Johor: [
    "Johor Bahru",
    "Iskandar Puteri",
    "Batu Pahat",
    "Kluang",
    "Muar",
    "Segamat",
    "Kulai",
    "Pontian",
    "Tangkak",
    "Pasir Gudang",
    "Kota Tinggi",
  ],
  Penang: [
    "George Town",
    "Bayan Lepas",
    "Seberang Perai",
    "Bukit Mertajam",
    "Butterworth",
    "Perai",
    "Nibong Tebal",
    "Sungai Petani",
    "Tanjung Tokong",
    "Gelugor",
    "Balik Pulau",
    "Batu Ferringhi",
  ],
  Perak: [
    "Ipoh",
    "Taiping",
    "Teluk Intan",
    "Sitiawan",
    "Batu Gajah",
    "Lumut",
    "Kampar",
    "Sungai Siput",
    "Ayer Tawar",
    "Bagan Serai",
    "Simpang Empat",
  ],
  Kedah: [
    "Alor Setar",
    "Kulim",
    "Sungai Petani",
    "Langkawi",
    "Padang Serai",
    "Jitra",
    "Yan",
    "Baling",
    "Sik",
    "Sik",
    "Pokok Sena",
  ],
  "Negeri Sembilan": [
    "Seremban",
    "Port Dickson",
    "Nilai",
    "Senawang",
    "Bahau",
    "Tampin",
    "Kuala Pilah",
    "Gemas",
  ],
  Melaka: [
    "Melaka City",
    "Ayer Keroh",
    "Bukit Beruang",
    "Jasin",
    "Tanjung Kling",
    "Alor Gajah",
    "Masjid Tanah",
    "Kuala Sungai Baru",
  ],
  Pahang: [
    "Kuantan",
    "Temerloh",
    "Bentong",
    "Mentakab",
    "Raub",
    "Jerantut",
    "Pekan",
    "Kuala Lipis",
    "Bandar Pusat Jengka",
  ],
  Terengganu: [
    "Kuala Terengganu",
    "Chukai",
    "Dungun",
    "Kemaman",
    "Marang",
    "Kuala Nerus",
    "Paka",
    "Jerteh",
  ],
  Kelantan: [
    "Kota Bharu",
    "Pangkal Kalong",
    "Tanah Merah",
    "Kuala Krai",
    "Pasir Mas",
    "Tumpat",
    "Pasir Puteh",
    "Gua Musang",
    "Machang",
  ],
  Perlis: ["Kangar", "Arau"],
  Sabah: [
    "Kota Kinabalu",
    "Sandakan",
    "Tawau",
    "Lahad Datu",
    "Keningau",
    "Putatan",
    "Semporna",
    "Kudat",
    "Penampang",
    "Tambunan",
    "Kota Belud",
  ],
  Sarawak: [
    "Kuching",
    "Miri",
    "Sibu",
    "Bintulu",
    "Miri",
    "Sarikei",
    "Sri Aman",
    "Kapit",
    "Limbang",
    "Betong",
  ],
};
